import { userData } from '@/store/Reducer/User/UserReducer';
import { useAppDispatch, useAppSelector } from '@/store/StoreHooks';
import defaultImg from '@assets/media/images/default-user.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './MyProfileDropdown.scss';

interface MyProfileProps {
  mobile?: boolean;
  desktop?: boolean;
  onNavigate?: () => void;
  closeDropdown?: () => void;
}

function MyProfileDropdown({
  mobile = false,
  desktop = false,
  onNavigate,
  closeDropdown,
}: MyProfileProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector((val) => val.userDetail);
  const location = useLocation();
  const userPaymentMethods = useAppSelector((val) => val.userDetail.member_payment_methods);

  const handleNavClick = (path: string) => {
    handleNavigation(path);
    if (onNavigate) {
      onNavigate();
    }
    closeDropdown?.();
  };

  const handleNavigation = (route: string) => {
    if(userPaymentMethods.length === 0){
      toast.warning('Please add payment method to continue.');  
      return;
    }
    navigate(route);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    dispatch(userData(null));
    if(mobile){
      onNavigate?.();
    }
    navigate('/login');
  };

  const navDesktopItems = [
    {
      path: '/profile/payment-method',
      icon: 'icon-card',
      label: 'Payment Method',
    },
    {
      path: '/profile/family-members',
      icon: 'icon-users',
      label: 'Family Members / Guests',
    },
    {
      path: '/profile/order-history',
      icon: 'icon-orders',
      label: 'Order History',
    },
    {
      path: '/profile/outstanding-dues',
      icon: 'icon-reminder',
      label: 'Outstanding Dues',
    },
    {
      path: '/profile/transaction-history',
      icon: 'icon-transaction-money',
      label: 'Transaction History',
    },
  ];

  const navItems = [
    { path: '/profile/my-account', icon: 'icon-user', label: 'My Profile' },
    {
      path: '/profile/payment-method',
      icon: 'icon-card',
      label: 'Payment Method',
    },
    {
      path: '/profile/family-members',
      icon: 'icon-users',
      label: 'Family Members / Guests',
    },
    {
      path: '/profile/order-history',
      icon: 'icon-orders',
      label: 'Order History',
    },
    {
      path: '/profile/outstanding-dues',
      icon: 'icon-reminder',
      label: 'Outstanding Dues',
    },
    {
      path: '/profile/transaction-history',
      icon: 'icon-transaction-money',
      label: 'Transaction History',
    },
  ];

  return (
    <>
      {desktop && (
        <>
          <div className="vcard" onClick={() => handleNavClick('/profile/my-account')}>
            <figure>
              <img src={user.photo || defaultImg} alt="user" />
            </figure>
            <div className="user-name">
              <h3>
                {user.first_name} {user.last_name}
              </h3>
              <Link to="/profile/my-account">My Profile</Link>
            </div>
          </div>
          <ul>
            {navDesktopItems.map((item) => (
              <li
                key={item.path}
                className={location.pathname === item.path ? 'active' : ''}
              >
                <button onClick={() => handleNavClick(item.path)}>
                  <i className={`cs-icon ${item.icon}`}></i>
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
      {mobile && (
        <div className="profile-page-ui">
          <div className="profile-page-content">
            <div className="nav-left">
              <div className="user-picture">
                <div className="vcard">
                  <figure>
                    <img
                      src={user.photo || defaultImg}
                      alt="profile"
                      className="avatar"
                    />
                  </figure>
                </div>
                <div className="user-name">
                  <h3>
                    {user.first_name} {user.last_name}
                  </h3>
                </div>
              </div>

              <nav className="profile-nav">
                <ul>
                  {navItems.map((item) => (
                    <li
                      key={item.path}
                      className={
                        location.pathname === item.path ? 'active' : ''
                      }
                    >
                      <button onClick={() => handleNavClick(item.path)}>
                        <i className={`cs-icon ${item.icon}`}></i>
                        {item.label}
                      </button>
                    </li>
                  ))}
                  <li>
                    <button onClick={handleLogout} className="logout-btn">
                      <i className="cs-icon icon-logout"></i>
                      Logout
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MyProfileDropdown;
